import React from 'react'
import PropTypes from 'prop-types'

function SingleValue(props) {
  const style = props.getStyles('singleValue', props)
  let progress = ''
  if (props.data.tasksDone) {
    progress =
      props.data.tasksTotal > 0 ? `${props.data.tasksDone} / ${props.data.tasksTotal}` : `${props.data.tasksDone}`
  }

  return (
    <div className="react-select__single-value" style={style}>
      <span>{props.children ? props.children : ''}</span>
      <div className="react-select__progress">{progress ? progress : ''}</div>
    </div>
  )
}
SingleValue.propTypes = {
  data: PropTypes.object,
  getStyles: PropTypes.func,
  children: PropTypes.any,
}

export default SingleValue
